import {
  PROFILE_CITY_OPTIONS_BY_COUNTRY,
  PROFILE_LOCATION_COUNTRIES,
} from "../../constants/profileLocations";

export const REGISTRATION_REGION_EU = "EU";
export const REGISTRATION_REGION_RU = "RU";
export const RU_REGISTRATION_COUNTRY_CODE = "RU";
const DEFAULT_EU_CITIES = [
  ["SK", "Bratislava"], ["CZ", "Prague"], ["AT", "Vienna"],
  ["HU", "Budapest"], ["PL", "Warsaw"], ["DE", "Berlin"],
  ["FR", "Paris"], ["IT", "Rome"], ["ES", "Madrid"],
  ["NL", "Amsterdam"],
];

const normalizeSearchValue = (value) =>
  String(value || "")
    .trim()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase();

const toCityOption = (country, name) => ({ country, name });

const SLOVAK_PREVIEW_ADDITIONAL_CITIES = ["Martin", "Poprad", "Prievidza"];

export function buildRegistrationPreviewCityOptions(query = "") {
  const featured = PROFILE_CITY_OPTIONS_BY_COUNTRY.SK || [];
  const queryKey = normalizeSearchValue(query);
  const approved = [...featured, ...SLOVAK_PREVIEW_ADDITIONAL_CITIES];
  const cities = queryKey
    ? approved.filter((city) => normalizeSearchValue(city).includes(queryKey))
    : approved;
  return cities.map((city) => toCityOption("SK", city));
}

const prioritizeCity = (cities, geoCity) => {
  const cityKey = normalizeSearchValue(geoCity);
  if (!cityKey) return cities;
  const matchIndex = cities.findIndex((city) => normalizeSearchValue(city) === cityKey);
  if (matchIndex <= 0) return cities;
  return [cities[matchIndex], ...cities.slice(0, matchIndex), ...cities.slice(matchIndex + 1)];
};

export function getRegistrationRegionFromHostname(hostname) {
  const host = String(hostname || "").trim().toLocaleLowerCase().replace(/\.$/, "");
  return host === "ru.vaultgrid.net" ? REGISTRATION_REGION_RU : REGISTRATION_REGION_EU;
}

export function canSubmitRegistrationIdentityStep({
  isSubmitting = false,
  registrationCodeLoading = false,
  registrationCode = "",
  acceptedTerms = false,
  isRussianLegalBundle = false,
  acceptedPersonalDataConsent = false,
} = {}) {
  return (
    !isSubmitting
    && !registrationCodeLoading
    && Boolean(registrationCode)
    && Boolean(acceptedTerms)
    && (!isRussianLegalBundle || Boolean(acceptedPersonalDataConsent))
  );
}

export function buildRegistrationCityOptions({
  registrationRegion = REGISTRATION_REGION_EU,
  geoCountry = "",
  geoCity = "",
  selectedCountry = "",
  query = "",
  localizeCity = (city) => city,
} = {}) {
  const normalizedGeoCountry = String(geoCountry || "").trim().toUpperCase();
  const ruContext = normalizedGeoCountry === RU_REGISTRATION_COUNTRY_CODE ||
    (registrationRegion === REGISTRATION_REGION_RU && !normalizedGeoCountry);

  let options;
  if (ruContext) {
    const cities = prioritizeCity(
      PROFILE_CITY_OPTIONS_BY_COUNTRY[RU_REGISTRATION_COUNTRY_CODE] || [],
      geoCity
    );
    options = cities.map((city) => toCityOption(RU_REGISTRATION_COUNTRY_CODE, city));
  } else {
    const knownCountry = PROFILE_LOCATION_COUNTRIES.some((country) => country.value === normalizedGeoCountry)
      || Boolean(PROFILE_CITY_OPTIONS_BY_COUNTRY[normalizedGeoCountry]);
    options = knownCountry
      ? prioritizeCity(PROFILE_CITY_OPTIONS_BY_COUNTRY[normalizedGeoCountry] || [], geoCity)
        .map((city) => toCityOption(normalizedGeoCountry, city))
      : DEFAULT_EU_CITIES.map(([country, city]) => toCityOption(country, city));
  }

  const queryKey = normalizeSearchValue(query);
  if (!queryKey) return options;
  return options.filter((option) => (
    normalizeSearchValue(option.name).includes(queryKey)
    || normalizeSearchValue(localizeCity(option.name)).includes(queryKey)
  ));
}
